var REGEX = {
    getSpaces: /\s/g,
    getSpecialCharactersAndNumbers: /[^a-zA-Z ]/g,
};
var removeSpecialCharactersAndSpaces = function (text) {
    return text.replace(REGEX.getSpecialCharactersAndNumbers, '').replace(REGEX.getSpaces, '');
};

export { removeSpecialCharactersAndSpaces };
//# sourceMappingURL=sanitizeText.esm.js.map
